import React from 'react'
import { Button, Popover, OverlayTrigger } from 'react-bootstrap'
import { ShareButtons, generateShareIcon } from 'react-share'

import './ShareButton.scss'

export const ShareButton = ({ shareUrl, buttonClass }) => {

  const { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } = ShareButtons

  const FacebookIcon = generateShareIcon('facebook')
  const TwitterIcon = generateShareIcon('twitter')
  const LinkedinIcon = generateShareIcon('linkedin')
  const WhatsappIcon = generateShareIcon('whatsapp')
  const title = 'LJ Ramos'

  const popoverShare = (
    <Popover id='popover-share'>
      <WhatsappShareButton
        url={shareUrl}
        title={title}>
        <WhatsappIcon
          size={20}
          round={false} />
      </WhatsappShareButton>
      <FacebookShareButton
        url={shareUrl}
        title={title}>
        <FacebookIcon
          size={20}
          round={false} />
      </FacebookShareButton>
      <TwitterShareButton
        url={shareUrl}
        title={title}>
        <TwitterIcon
          size={20} />
      </TwitterShareButton>
      <LinkedinShareButton
        url={shareUrl}
        title={title}>
        <LinkedinIcon
          size={20} />
      </LinkedinShareButton>
    </Popover>
  )

  return (
    <div className={'ljr-share-button-container ljr-banner-share-button'}>
      <OverlayTrigger trigger='click' rootClose placement='top' overlay={popoverShare}>
        <Button className='ljr-share-button'>
          <i className='fa fa-share-alt fa-lg'></i>
        </Button>
      </OverlayTrigger>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/commons/ShareButton/ShareButton.component.js